import { Injectable, inject } from '@angular/core';

import { LoaderStylesService } from '@frontend/loaders';
import { ModuleLoaderService } from '@frontend/sports/deferred/feature/module-loader';
import { Observable, forkJoin, from, map } from 'rxjs';

import { SitemapModule } from '../sitemap/sitemap.module';

@Injectable({ providedIn: 'root' })
export class SitemapModuleLoaderService {
    private moduleLoader = inject(ModuleLoaderService);

    private readonly styleSheet = 'sports-sitemap';
    private readonly loaderStylesService = inject(LoaderStylesService);

    loadAndInitModule(): Observable<SitemapModule> {
        const moduleLoader = this.moduleLoader.loadModule<SitemapModule>('SitemapModule', () =>
            import(/* webpackChunkName: "ms-sitemap" */ '../sitemap/sitemap.module').then((m) => m.SitemapModule),
        );
        const stylesLoader = from(this.loaderStylesService.loadStyles([{ id: this.styleSheet, type: 'theme' }]));

        return forkJoin([moduleLoader, stylesLoader]).pipe(map(([ref, _]) => ref.instance));
    }
}
